import React from 'react';
import classnames from 'classnames';
import { DateTime } from 'luxon';
import { timeAgoInWords } from 'helpers/date';
import styles from './ItemMetadata.module.scss';

interface ItemMetadataProps {
  className: string;
  modified: number;
  created?: number;
  integrationType: string;
}
export const ItemMetadata: React.FC<ItemMetadataProps> = ({
  className,
  modified,
  created = null,
  integrationType,
}) => {
  const classes = classnames(className, styles.container);
  const displayModified = timeAgoInWords(DateTime.fromMillis(modified * 1000));
  let displayCreated: any = created
    ? timeAgoInWords(DateTime.fromMillis(created * 1000), undefined, '')
    : null;

  if (integrationType.includes('dropbox')) {
    displayCreated = null;
  }

  return (
    <div className={classes}>
      <DisplayModified modified={displayModified} />
      {displayCreated && <DisplayCreated created={displayCreated} />}
    </div>
  );
};

interface DisplayModifiedProps {
  modified: string;
}

export const DisplayModified: React.FC<DisplayModifiedProps> = ({ modified }) => {
  return (
    <span className={styles.metaWrap}>
      <span className={styles.itemMetaBold}>Modified: </span>
      {modified}
    </span>
  );
};

interface DisplayCreatedProps {
  created: string;
}

export const DisplayCreated: React.FC<DisplayCreatedProps> = ({ created }) => {
  return (
    <>
      <span className={styles.infoBullet} />
      <span className={styles.metaWrap}>
        <span className={styles.itemMetaBold}>Age: </span>
        {created}
      </span>
    </>
  );
};
